import axios from "axios";
import tokenCtrl from '@/library/token';
import router from "@/router"
import store from "@/store"

const baseURL = "https://api.jbfc.kr"; // 라이브
// const baseURL = "https://api-jbhd.thesports.io" // 개발
const instance = axios.create({
    baseURL: baseURL,
    headers: { "content-type": "application/json" },
    timeout: 30000,
    withCredentials: true,
    crossDomain: true,
    credentials: "include"
});

instance.interceptors.request.use(
    async config => {

        // Access token expire check
        return await tokenCtrl.accessTokenChk(config);
    },
    error => {
        console.log('@@@@@ request error @@@@@');
        return Promise.reject(error);
    }
);


instance.interceptors.response.use(
    (res) => {
        return res
    },
    (error) => {
        const currentPath = router.currentRoute.path;

        if (error.response?.status === 400) {
            const isSignUp = currentPath.includes('/signup'); // 회원가입
            const isSignIn = currentPath.includes('/signin'); // 로그인
            const isMyInfo = currentPath.includes('/myinfo'); // 마이페이지에서 비밀번호 확인
            const smartTkPath = currentPath.includes('/giftTicket'); // 스마트티켓 관련 경로
            const isAuthRelated = isSignIn || isMyInfo || isSignUp|| smartTkPath;

            if (isAuthRelated) {
                return Promise.reject(error); // 비밀번호 불일치시 에러페이지 이동하지 않도록
            }

            // 나머지는 에러 페이지로 이동
            router.push({ name: 'errorPage' });
            return Promise.reject(error);
        }

        if (error.response?.status === 401) {
            if (error.response.data.message === 'Failed to authenticate token') {
                store.commit('logout');
                return;
            }

            const isSignIn = currentPath.includes('/signin'); // 로그인 시도 중
            const isAuthCode = error.config.url?.includes('/message/auth_code_confirm'); // 인증코드 확인 API

            if (isSignIn || isAuthCode) {
                return Promise.reject(error); // 에러페이지로 이동하지 않고 컴포넌트에서 처리하도록
            }

            alert('로그인이 필요한 서비스입니다.');
            localStorage.clear();
            return router.push({ name: 'signin' });
        }

        if (error.code === 'ERR_NETWORK') {
            return router.push({ name: 'serverErrorPage' });
        }

        if (error.response && Number(error.response.status) >= 500) {
            return router.push({ name: 'serverErrorPage' });
        }

        return Promise.reject(error);
    }
)


export default instance;
